<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="showOrderInfo.orderNo ? '' : 'info'">
        {{ showOrderInfo.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="
          $jsTool.getOrderApprovalStatusType(
            showOrderInfo.orderApprovalStatusEnum
          )
        "
        >{{ showOrderInfo.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="showOrderInfo.orderNo ? '' : 'info'">
        {{ showOrderInfo.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="2">
      {{ showOrderInfo.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="转出账户">
      <div class="fm-flex">
        <el-image
          style="width: 18px; height: 18px"
          fit="cover"
          class="fm-margin-right-5"
          :src="
            $jsTool.getFundAccountImageSrc(
              showOrderInfo.outFundAccount.fundAccountTypeEnum
            )
          "
        ></el-image>
        {{ showOrderInfo.outFundAccount.name }}
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="转出日期">
      {{ showOrderInfo.outDate }}
    </el-descriptions-item>
    <el-descriptions-item label="转出金额">
      <FmAmount :amount="showOrderInfo.outAmount"></FmAmount>
    </el-descriptions-item>
    <el-descriptions-item label="手续费" span="3">
      <FmAmount :amount="showOrderInfo.chargeFeeAmount"></FmAmount>
    </el-descriptions-item>
    <el-descriptions-item label="转入账户">
      <div class="fm-flex">
        <el-image
          style="width: 18px; height: 18px"
          fit="cover"
          class="fm-margin-right-5"
          :src="
            $jsTool.getFundAccountImageSrc(
              showOrderInfo.inFundAccount.fundAccountTypeEnum
            )
          "
        ></el-image>
        {{ showOrderInfo.inFundAccount.name }}
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="到账日期">
      {{ showOrderInfo.inDate }}
    </el-descriptions-item>
    <el-descriptions-item label="到账金额">
      <FmAmount :amount="showOrderInfo.inAmount"></FmAmount>
    </el-descriptions-item>
    <el-descriptions-item label="业务员" span="3">
      {{ showOrderInfo.saleUserList.map((d) => d.user.name).join("、") }}
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="showOrderInfo.remark ? '' : 'warning'">{{
        showOrderInfo.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="流程信息" span="3">
      <OrderStep
        :orderInfo="showOrderInfo"
        :displayTime="displayTime"
      ></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebFundAccountTransferOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = newVal;
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:FundAccountTransferOrder:NeedApproval",
        "Order:FundAccountTransferOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:FundAccountTransferOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:FundAccountTransferOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.fundAccountTransferOrder_findById(
        this.orderInfo.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/FundAccountTransferOrderInfo.vue